import React from 'react';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import {object} from 'prop-types';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';

import WeatherDataActionCell from './WeatherDataActionCell';

import classes from './WeatherDataInsert.module.css';

const WeatherDataInsert = ({onToggleWeatherDataModal}) => {
    const weatherStation = useSelector(
        ({ architect: { weatherStation }}) => weatherStation
    );

    const renderTable = () => {
        if (isEmpty(weatherStation)) {
            return (
                <div className={classes.noWeatherStation}>
                    <span>No Weather Station Data Available</span>
                </div>
            );
        }

        return (
            <Table className={classes.table}>
                <TableHead>
                    <TableRow>
                        <TableCell className={classes.headerCell}>
                            Name
                        </TableCell>
                        <TableCell className={classes.headerCell}>
                            Location
                        </TableCell>
                        <TableCell className={classes.headerCell} />
                    </TableRow>
                </TableHead>
                <TableBody>
                    {weatherStation.map(item =>
                        <TableRow key={item.id}>
                            <TableCell className={`${classes.dataCell} ${classes.ellipseCell}`}>
                                <Tooltip
                                    title={
                                        <span className={classes.tooltip}>
                                            {item.name}
                                        </span>
                                    }
                                    placement="top-start"
                                >
                                    <span>{item.name}</span>
                                </Tooltip>
                            </TableCell>
                            <TableCell className={`${classes.dataCell} ${classes.ellipseCell}`}>
                                <Tooltip
                                    title={
                                        <span className={classes.tooltip}>
                                            {item.zipcode}
                                        </span>
                                    }
                                    placement="top-start"
                                >
                                    <span>{item.zipcode}</span>
                                </Tooltip>
                            </TableCell>
                            {
                                process.env.weatherDataModalEnabled &&
                                <WeatherDataActionCell onToggleWeatherDataModal={onToggleWeatherDataModal} weatherdata={weatherStation} />
                            }
                            {
                                // NOTE: the below self-closing TableCell component has been added to prevent a css glitch and should be removed when
                                // the feature flag above is removed
                                <TableCell />
                            }
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        );
    };

    return (
        <React.Fragment>
            {renderTable()}
        </React.Fragment>
    );
};

WeatherDataInsert.defaultProps = {
    node: {}
};

WeatherDataInsert.propTypes = {
    node: object.isRequired
};

export default WeatherDataInsert;
